import { render } from "./TV.vue?vue&type=template&id=efe26f0e&scoped=true"
import script from "./TV.vue?vue&type=script&lang=js"
export * from "./TV.vue?vue&type=script&lang=js"

import "./TV.vue?vue&type=style&index=0&id=efe26f0e&lang=css&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efe26f0e"]])

export default __exports__